import React from "react";
import {
  TextField,
  Box,
  Paper,
  Typography,
  FormControl,
  FormLabel,
  Button,
  Tooltip,
  IconButton,
  Breadcrumbs,
  MenuItem,
  Alert,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { Formik } from "formik";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  fetchApidata,
  getFetchData,
  getFetchsalaryData,
  postApidata,
  postData,
  requestMail,
} from "../../../store/reducers/Formapireducer";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import GradingIcon from "@mui/icons-material/Grading";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useEffect, useState, useRef } from "react";
import Popup from "../popup";
import Listviewpopup from "../Lookup";
import Swal from "sweetalert2";
import { LoadingButton } from "@mui/lab";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { FinanceSchema } from "../../Security/validation";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import axios from "axios";
import store from "../../../index";
import {
  fileUpload,
  imageUpload,
} from "../../../store/reducers/Imguploadreducer";

import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { financeentrySchema } from "../../Security/validation";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import {
  Employeeautocomplete,
  MultiFormikOptimizedAutocomplete,
  CheckinAutocomplete
} from "../../../ui-components/global/Autocomplete";
import { formGap } from "../../../ui-components/global/utils";
import { leaveAppoval } from "../../../store/reducers/Listviewapireducer";

const EditQuery = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const accessID = params.accessID;
  const recID = params.id;
  const EMPID = sessionStorage.getItem("EmpId");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const mode = params.Mode;
  const rowSx = { height: 36, "& td, & th": { py: 0.5 } };
  console.log(params, "find Screen Params");
  var parentID = params.parentID;
  console.log(parentID, "--parentID");
  const filtertype = params.filtertype;
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const rowData = location.state || {};
  console.log(rowData, "--find rowData");
  const navigate = useNavigate();
  const data = useSelector((state) => state.formApi.Data);
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const Finyear = sessionStorage.getItem("YearRecorid");
  const CompanyID = sessionStorage.getItem("companyId");
  console.log(CompanyID, "--CompanyID");  
  const CompanyAutoCode = sessionStorage.getItem("CompanyAutoCode");


  // companyId
  const [validationSchema, setValidationSchema] = useState(null);
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [errorMsgData, setErrorMsgData] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        let schemaFields = {
          comments: Yup.string().required(data.Milestone.comments),
          querycomments: Yup.string().required(data.Milestone.querycomments),
          Status: Yup.string().required(data.Milestone.Status),
        };

        if (CompanyAutoCode === "N") {
          schemaFields.code = Yup.string().required(data.Milestone.code);
        }

        const schema = Yup.object().shape(schemaFields);
        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID }));
    var url = store.getState().globalurl.empGetAttachmentUrl;
    axios
      .get(url, {
        params: {
          empId: EMPID,
          appId: recID,
        },
      })
      .then((response) => {
        setFiles(response.data);
      })
      .catch((err) => {
        setError("Failed to fetch attachments.");
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, []);
  const [ImageName, setImgName] = useState("");
  const [selectedCC, setSelectedCC] = useState([]);
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const currentDate = new Date().toISOString().split("T")[0];

  // let parsedCC = [];
  // try {
  //   parsedCC = data.EmailCC ? JSON.parse(data.EmailCC) : [];
  // } catch (e) {
  //   parsedCC = [];
  //   console.error("Invalid JSON in EmailCC:", data.EmailCC);
  // }

  const initialValue = {
    date: data.DateTime,
    mailto: data.EmailTo
      ? {
        RecordID: data.EmailTo,
        // Code: data.EmployeeCode,
        Name: data.EmailToName,
      }
      : null,
    // mailcc: data.EmailCCNames,
    mailcc: data.EmailCC ? JSON.parse(data.EmailCC) : [],
    subject: data.Subject,
    comments: data.Comments,
    querycomments: data.QueryComments,
    Status: data.Status,

  };

  //  const parsed = JSON.parse(data.EmailCC);
  //   console.log(parsed, "--JSON.parse(data.EmailCC)");
  const QuerySaveFn = async (values, resetForm, del) => {
    setLoading(true);
    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";

    const idata = {
      RecordID: recID,
      DateTime: values.date,
      EmailTo: values.mailto?.RecordID || 0,
      EmailToName: values.mailto?.Name || "",
      EmailCC: JSON.stringify(selectedCC),
      Subject: values.subject,
      Comments: values.comments,
      EmployeeID: mode == "M" ? params.parentID : EMPID,
      QueryComments: values.querycomments || "",
      Status:
        mode == "A"
          ? "AL"
          : mode == "E" && values.Status == "RC"
            ? "AL"
            : values.Status,
    };
    const response = await dispatch(
      postData({ accessID: "TR271", action, idata })
    );
    if (response.payload.Status == "Y") {
      setLoading(false);
      if (mode == "A") {
        dispatch(
          requestMail({
            EmployeeID: EMPID,
            Type: "QR",
            RecordID: response.payload.Recid,
          })
        );
        dispatch(
          leaveAppoval({
            data: {
              RecordID: response.payload.Recid,
              ManagerID: EMPID,
              EmployeeID: EMPID,
              Type: "QR",
              Status: "AL",
              Reason: "",
            },
          })
        );
      }
      if (mode == "M") {
        dispatch(
          leaveAppoval({
            data: {
              RecordID: recID,
              ManagerID: EMPID,
              EmployeeID: params.parentID,
              Type: "QR",
              Status:
                values.Status == "AP"
                  ? "Y"
                  : values.Status == "QR"
                    ? values.Status
                    : "N",
              Reason: "",
              Source: "M",
            },
          })
        );
      }

      toast.success(response.payload.Msg);
      navigate(-1);
      resetForm();
    } else {
      setLoading(false);
      toast.error(response.payload.Msg);
    }
  };

  const [isPopupData, setisPopupdata] = React.useState(false);
  const [selectOHLookupData, setselectOHLookupData] = React.useState({
    OHlookupRecordid: "",
    OHlookupCode: "",
    OHlookupDesc: "",
  });
  if (isPopupData == false) {
    selectOHLookupData.OHlookupRecordid = data.OverHeadsID;
    selectOHLookupData.OHlookupCode = data.Code;
    selectOHLookupData.OHlookupDesc = data.Name;
  }

  const [openOHPopup, setOpenOHPopup] = useState(false);
  // const [openEMPLOYEEPopup, setOpenEMPLOYEEPopup] = useState(false);
  //   function handleShow(type) {
  //     if (type == "OH") {
  //       setOpenOHPopup(true);
  //     }

  //   }

  const childToParent = (childdata, type) => {
    console.log("type---" + type);
    console.log("Data---" + JSON.stringify(childdata));

    if (type == "OverHead") {
      setisPopupdata(true);
      setselectOHLookupData({
        OHlookupRecordid: childdata.RecordID,
        OHlookupCode: childdata.Code,
        OHlookupDesc: childdata.Name,
      });
      setOpenOHPopup(false);
    }
  };
  const ref = useRef(null);
  // *************** GET FILES FROM INPUT *************** //

  const getFileChange = async (event) => {
    setImgName(event.target.files[0]);

    console.log(event.target.files[0]);

    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("type", "attachments");

    const fileData = await dispatch(imageUpload({ formData }));
    setImgName(fileData.payload.name);
    console.log(">>>", fileData.payload);
    console.log(
      "🚀 ~ file: Editdeliverychalan.jsx:1143 ~ getFileChange ~ fileData:",
      fileData
    );
    if (fileData.payload.Status == "Y") {
      toast.success(fileData.payload.Msg);
    }
  };
  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate(-1);
        }
      } else {
        return;
      }
    });
  };
  async function fileUpload(file) {
    console.log("🚀 ~ fileUpload ~ file:", file);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("empId", EMPID);
    formData.append("appId", data.RecordID);
    formData.append("type", "QR");
    formData.append("source", "Query");
    console.log("🚀 ~ fileUpload ~ formData:", formData);
    const respose = await dispatch(attachmentPost({ data: formData }));

    if (respose.payload.success) {
      toast.success(respose.payload.message);
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: EMPID,
            appId: data.RecordID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setLoading(false));
    } else {
      toast.success(respose.payload.message);
    }

    console.log("🚀 ~ fileUpload ~ respose:", respose);
  }
  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Box display="flex" borderRadius="3px" alignItems="center">
            <Breadcrumbs
              maxItems={3}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
            >
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
              >
                Query
              </Typography>
            </Breadcrumbs>
          </Box>
          <Box display="flex">
            <IconButton color="error" onClick={() => fnLogOut("Close")}>
              <ResetTvIcon />
            </IconButton>
            <IconButton>
              <LogoutOutlinedIcon
                color="error"
                onClick={() => fnLogOut("Logout")}
              />
            </IconButton>
          </Box>
        </Box>
      </Paper>
      {!getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {/* <Box m="20px"> */}
          <Formik
            initialValues={initialValue}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                QuerySaveFn(values);
              }, 100);
            }}
            // validationSchema={financeentrySchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
              resetForm,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  // gap="5px"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", gap: "15px" }}
                  >
                    <TextField
                      //   disabled={
                      //     mode == "E" &&
                      //     values.Status != "AL" &&
                      //     values.Status != "RC"
                      //   }
                      name="date"
                      type="date"
                      id="date"
                      label="Date"
                      variant="standard"
                      focused
                      value={values.date}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      inputFormat="YYYY-MM-DD"
                      error={!!touched.date && !!errors.date}
                      helperText={touched.date && errors.date}
                      autoFocus
                    />
                    {/* <TextField
                      name="applieddate"
                      type="date"
                      id="applieddate"
                      label="Applied Date"
                      variant="standard"
                      focused
                      inputFormat="YYYY-MM-DD"
                      value={values.applieddate}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.applieddate && !!errors.applieddate}
                      helperText={touched.applieddate && errors.applieddate}
                      sx={{ gridColumn: "span 2" }}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                        readOnly: true,
                      }}
                      disabled={
                        mode == "E" &&
                        values.Status != "AL" &&
                        values.Status != "QR"
                      }
                    /> */}
                    <CheckinAutocomplete

                      // disabled={ mode === "V" || mode == "TO"}
                      sx={{ gridColumn: "span 2" }}
                      name="mailto"
                      label="To"
                      id="mailto"
                      value={values.mailto}
                      onChange={(newValue) => {
                        setFieldValue("mailto", newValue);
                      }}
                      error={!!touched.mailto && !!errors.mailto}
                      helperText={touched.mailto && errors.mailto}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2110","ScreenName":"Mail CC","Filter":"CompanyID=${CompanyID}","Any":"","CompId":${CompanyID}}}`}

                    //   if (newValue) {
                    //     //   setempData(newValue);
                    //     setFieldValue("empCode", newValue.Code);
                    //     console.log(newValue, "--mailto newValue");
                    //     //console.log(values.empName.RecordID,"Empdata");
                    //     //setEmpId(values.empName.RecordID);
                    //   } else {
                    //     //   setempData("");
                    //     setFieldValue("empCode", "");
                    //   }
                    // }}
                    //   url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2110","ScreenName":"Mail TO","Filter":"parentID=${EMPID} AND CompanyID=${CompanyID}","Any":"","CompId":${CompanyID}}}`}

                    //   url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2101","ScreenName":"Mail CC","Filter":"parentID=${EMPID}","Any":"","CompId":${CompanyID}}}`}
                    />
                    <FormControl sx={{ flex: 1, minWidth: 180, width: "100%" }}>
                      {/* <MultiFormikOptimizedAutocomplete
                        sx={{ width: "100%" }}
                        name="mailcc"
                        label="CC"
                        id="mailcc"
                        value={selectedCC}
                        onChange={(e, newValue) => {
                          setFieldValue("mailcc", newValue);
                          setSelectedCC(newValue);
                        }}
                        url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2110","ScreenName":"Mail CC","Filter":"CompanyID=${CompanyID}","Any":"","CompId":${CompanyID}}}`}
                      /> */}
                      <MultiFormikOptimizedAutocomplete
                        name="mailcc"
                        label="CC"
                        id="mailcc"
                        value={selectedCC}
                        onChange={(e, newValue) => {
                          setFieldValue("mailcc", newValue);
                          setSelectedCC(newValue);
                        }}
                        getOptionLabel={(option) => option?.Name || ""} // <- Show Name
                        url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2110","ScreenName":"Mail CC","Filter":"CompanyID=${CompanyID}","Any":"","CompId":${CompanyID}}}`}
                      />
                    </FormControl>

                    {/* <Employeeautocomplete
                                    disabled={ mode === "V" || mode == "TO"}
                                      sx={{ gridColumn: "span 2" }}
                                      name="empName"
                                      label="To"
                                      id="empName"
                                      value={values.empName}
                                      onChange={(newValue) => {
                                        setFieldValue("empName", newValue); 
                    
                                        if (newValue) {
                                        //   setempData(newValue); 
                                          setFieldValue("empCode", newValue.Code);
                                          console.log(newValue.RecordID, "--selectedproductid");
                                          //console.log(values.empName.RecordID,"Empdata");
                                          //setEmpId(values.empName.RecordID);
                                        } else {
                                        //   setempData("");
                                          setFieldValue("empCode", ""); 
                                        }
                                      }}
                                      url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${CompanyID}}}`}
                                    /> */}

                    {/* <TextField
                      disabled={
                        mode == "E" &&
                        values.Status != "AL" &&
                        values.Status != "QR"
                      }
                      name="cc"
                      type="text"
                      id="cc"
                      label="CC"
                      variant="standard"
                      focused
                      value={values.cc}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={
                        !!touched.cc && !!errors.cc
                      }
                      helperText={
                        touched.cc && errors.cc
                      }
                      autoFocus
                    /> */}

                    <TextField
                      //   disabled={
                      //     mode == "E" &&
                      //     values.Status != "AL" &&
                      //     values.Status != "QR"
                      //   }
                      name="subject"
                      type="text"
                      id="subject"
                      label="Subject"
                      variant="standard"
                      focused
                      value={values.subject}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.subject && !!errors.subject}
                      helperText={touched.subject && errors.subject}
                      autoFocus
                    />

                    <TextField
                      //   disabled={
                      //     mode == "E" &&
                      //     values.Status != "AL" &&
                      //     values.Status != "QR"
                      //   }
                      fullWidth
                      variant="outlined"
                      type="text"
                      label={<>Comments<span style={{ color: "red", fontSize: "20px" }}>*</span></>}
                      // required
                      multiline
                      rows={5}
                      value={values.comments}
                      id="comments"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="comments"
                      error={!!touched.comments && !!errors.comments}
                      helperText={touched.comments && errors.comments}
                      sx={{
                        gridColumn: "span 2",
                        backgroundColor: "",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "",
                        },
                      }}
                      focused
                    />

                    {mode == "M" && (
                      // (mode == "E" &&
                      //   (values.Status == "RJ" || values.Status == "QR")) ? (
                      <TextField
                        // disabled={mode == "E" && values.Status != "AL"}
                        fullWidth
                        variant="outlined"
                        type="text"
                        label={<>Query Comments<span style={{ color: "red", fontSize: "20px" }}>*</span></>}
                        // required
                        multiline
                        rows={5}
                        value={values.querycomments}
                        id="querycomments"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="querycomments"
                        error={!!touched.querycomments && !!errors.querycomments}
                        helperText={touched.querycomments && errors.querycomments}
                        sx={{
                          gridColumn: "span 2",
                        }}
                        focused
                      />
                    )}
                    {mode == "M" && (
                      <TextField
                        select
                        label="Status"
                        id="Status"
                        name="Status"
                        value={values.Status}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        // required
                        focused
                        variant="standard"
                      >
                        {mode != "M" && <MenuItem value="AL">Applied</MenuItem>}
                        <MenuItem disabled={mode != "M"} value="AP">
                          Approved
                        </MenuItem>
                        <MenuItem disabled={mode != "M"} value="RJ">
                          Rejected
                        </MenuItem>
                        {mode == "M" && <MenuItem value="QR">Query</MenuItem>}
                      </TextField>
                    )}

                    {mode == "E" && values.Status == "AP" && (
                      <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                        Your Query Approved.
                      </Alert>
                    )}
                    {mode == "E" && values.Status == "RJ" && (
                      <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                        Your Rejected.
                      </Alert>
                    )}
                    {mode == "E" && values.Status == "QR" && (
                      <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                        Your Query Status Query.
                      </Alert>
                    )}
                  </FormControl>
                </Box>
                <Box
                  display="flex"
                  padding={1}
                  justifyContent="end"
                  mt="20px"
                  gap="20px"
                >
                  {/* {mode === "E" ? ( */}
                  <Box display="flex" alignItems="center" gap={1}>
                    <FileUploadIconButton onFileSelect={fileUpload} />
                    {/* <Tooltip title="View Uploaded Files">
                        <GradingIcon

                          onClick={() => setOpen(true)}
                          color="primary"
                          sx={{ cursor: 'pointer' }}
                        />
                      </Tooltip> */}
                  </Box>
                  {/* //   ) : null} */}
                  {/* {mode != "M" &&
                    (values.Status == "AL" ||
                      values.Status == "QR" ||
                      mode == "A") && (
                      <LoadingButton
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={loading}
                      >
                        Save
                      </LoadingButton>
                    )} */}
                  {/* {mode == "M" && ( */}
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={loading}
                  >
                    Save
                  </LoadingButton>
                  {/* //   )} */}
                  {mode != "M" && values.Status == "AL" && (
                    <Button
                      color="error"
                      variant="contained"
                      onClick={() => {
                        Swal.fire({
                          title: errorMsgData.Warningmsg.Delete,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Confirm",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            QuerySaveFn(values, resetForm, "harddelete");
                            // navigate(-1);
                          } else {
                            return;
                          }
                        });
                      }}
                    >
                      Delete
                    </Button>
                  )}
                  {mode == "M" && (
                    <Button
                      color="error"
                      variant="contained"
                      onClick={() => {
                        Swal.fire({
                          title: `Do you want Delete?`,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Confirm",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            QuerySaveFn(values, resetForm, "harddelete");
                            // navigate(-1);
                          } else {
                            return;
                          }
                        });
                      }}
                    >
                      Delete
                    </Button>
                  )}

                  <Button
                    type="reset"
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
          <FileListPopup
            open={open}
            onClose={() => setOpen(false)}
            appId={recID}
            empId={EMPID}
          />
          <Popup
            title="Purpose"
            openPopup={openOHPopup}
            setOpenPopup={setOpenOHPopup}
          >
            <Listviewpopup
              accessID="2032"
              screenName="OverHead"
              childToParent={childToParent}
              filterName={"FinanceCategoryType"}
              filterValue={parentID}
            />
          </Popup>
        </Paper>
      ) : (
        false
      )}
      {mode === "E" && files.length > 0 ? (
        <Box mt={2}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={rowSx}>
                    <TableCell width={20}>
                      <strong>SL#</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Uploaded Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Filename</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Source</strong>
                    </TableCell>
                    <TableCell>
                      <strong>View</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {files.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No files uploaded yet.
                      </TableCell>
                    </TableRow>
                  ) : (
                    files.map((file, index) => (
                      <TableRow key={file.id || index} sx={rowSx}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file.uploadedDate}</TableCell>
                        <TableCell>{file.filename}</TableCell>
                        <TableCell>{file.source}</TableCell>
                        <TableCell>
                          <Tooltip title="Open File">
                            <IconButton
                              color="primary"
                              component="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                            >
                              <OpenInNewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      ) : null}
    </React.Fragment>
  );
};

export default EditQuery;
